import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { showError, sortArray } from '@utils';
import { permissionsServices } from '@services';
import { AGENT_ROLES, LIMIT } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';
import { rolesOptions } from 'components/agents/rolesOptions';

import { handlePermissionsData, getAsyncExportPayload } from './utils';

export const PERMISSIONS_PAGE_SIZE = LIMIT;

export const usePermissionsOperations = () => {
  const router = useRouter();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || PERMISSIONS_PAGE_SIZE;
  const role = router.query?.role || AGENT_ROLES.isAdmin;

  const exportPayload = useMemo(() => getAsyncExportPayload({ role }), [role]);

  const permissionsResponse = useQuery(
    [QUERY_KEYS.GET_PERMISSIONS_KEY, { page, pageSize, role }],
    () =>
      permissionsServices.getPermissions({
        page,
        pageSize: parseInt(pageSize, 10) || PERMISSIONS_PAGE_SIZE,
        role,
      })
  );

  useEffect(() => {
    if (permissionsResponse?.error) {
      showError(permissionsResponse?.error);
    }
  }, [permissionsResponse?.error]);

  const roles = sortArray([...rolesOptions], 'label')?.map((r) => ({
    text: r?.label,
    value: r?.value,
  }));

  return {
    page,
    permissions: handlePermissionsData(permissionsResponse?.data?.data),
    pageSize: parseInt(pageSize, 10) || PERMISSIONS_PAGE_SIZE,
    total: permissionsResponse?.data?.meta?.total,
    loading: permissionsResponse?.isLoading,
    error: permissionsResponse?.error,
    roles,
    role,
    exportPayload,
    refetch: permissionsResponse.refetch,
  };
};
